import React, { useState, useEffect, useRef } from "react";
import {
  Tabs,
  Modal,
  Input,
  Radio,
  Switch,
  Checkbox,
  Tooltip,
  // message,
  Spin,
} from "antd";
import message from "./components/custom_message";
import "./CommunicationSetupNew.css";
import {
  MailOutlined,
  MessageOutlined,
  SettingOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { UR_Owner } from "State";
import { checkAccess } from "../../Auth";
import TeamEmailSetupContent from "./components/teamEmailSetupContent";
import { track, flushThenLeave } from "statsig";
import { STATSIG, PAGE, pageByMenu } from "statsig/events";


export default function CommunicationSetupNew() {
  const [hasEmailSetup, setHasEmailSetup] = useState(false);
  const [hasOldEmailSetup, setHasOldEmailSetup] = useState(false);
  const [showNotificationEmailDialog, setshowNotificationEmailDialog] =
    useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [currentType, setCurrentType] = useState("");
  const [showCompanyEmailDialog, setshowCompanyEmailDialog] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [googleAdminAccount, setGoogleAdminAccount] = useState("");
  const [microsoftAdminAccount, setMicrosoftAdminAccount] = useState("");
  // todo: default value come from api
  const [isSmsEnabled, setIsSmsEnabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showLearnMoreDialog, setShowLearnMoreDialog] = useState(false);
  const [individualEmail, setIndividualEmail] = useState("");
  const [systemNotificationsEmail, setSystemNotificationsEmail] = useState("noreply@zeitro.com"); // default
  const [isTeamDefaultSender, setIsTeamDefaultSender] = useState(false);
  const [defaultEmail, setDefaultEmail] = useState("");
  const [isIndividualDefaultSender, setIsIndividualDefaultSender] =
    useState(false);
  const [showEmailTypeDialog, setshowEmailTypeDialog] = useState(false);
  const [emailType, setEmailType] = useState(1); // 1 for team, 2 for individual
  const [selectedEmailType, setSelectedEmailType] = useState(""); // 1 for team, 2 for individual
  const [showIndividualEmailDialog, setshowIndividualEmailDialog] =
    useState(false);
  const [showDifferentIndividualWarning, setShowDifferentIndividualWarning] =
    useState(false);
  const [personalSiteEmail, setPersonalSiteEmail] = useState("");

  const [showTeamEmailSetupDialog, setShowTeamEmailSetupDialog] =
    useState(false);

  const [
    showIndividualEmail_SuccessDialog,
    setshowIndividualEmail_SuccessDialog,
  ] = useState(false);

  const [openNotificationDailog, setOpenNotificationDailog] = useState(false);
  const [notificationEmailInput, setNotificationEmailInput] = useState("");
  const [notificationErrorMessage, setNotificationErrorMessage] = useState("");

  const [numFlag, setNumFlag] = useState(0);

  const [loadingObj, setLoadingObj] = useState({
    emailType: false,
    individualEmail: false,
    notificationEmail: false,
  });

  const [isEditDefaultEmail, setIsEditDefaultEmail] = useState(true);

  const [showRemoveEmailConfirm, setShowRemoveEmailConfirm] = useState(false);
  const [removeType, setRemoveType] = useState(null);

  const host = window.location.host;
  const getProtocol = () => {
    return host.includes('localhost') ? 'http' : 'https';
  };
  const redirect_uri = `${getProtocol()}://${host}/app/management`;

  const check_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="26"
        viewBox="0 0 42 26"
        fill="none"
      >
        <rect width="42" height="26" rx="13" fill="#325CEB" />
        <rect x="17" y="2" width="22" height="22" rx="11" fill="white" />
      </svg>
    );
  };

  const close_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="26"
        viewBox="0 0 42 26"
        fill="none"
      >
        <rect width="42" height="26" rx="13" fill="#DBDCDE" />
        <rect x="3" y="2" width="22" height="22" rx="11" fill="white" />
      </svg>
    );
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const getConfig = () => {
    return fetch("/los/getcommunicationconfig", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log("config: ", data);
        // {
        // IndividualEmail: null,
        // TeamEmail: null,
        // SystemNotificationsEmail: null,
        // SMSAlertOn: false,
        // defaultEmail: ''
        // }
        data.IndividualEmail && setIndividualEmail(data.IndividualEmail.Email);

        // todo
        data.TeamEmail && setGoogleAdminAccount(data.TeamEmail.Email);

        data.NotificationEmail &&
          setSystemNotificationsEmail(data.NotificationEmail.Email);

        data.SMSAlertOn && setIsSmsEnabled(data.SMSAlertOn);

        if (data.DefaultEmail === "individual") {
          setIsIndividualDefaultSender(true);
          setIsTeamDefaultSender(false);
          setDefaultEmail("individual");
        } else if (data.DefaultEmail === "team") {
          setIsTeamDefaultSender(true);
          setIsIndividualDefaultSender(false);
          setDefaultEmail("team");
        }
        return data;
      });
  };

  const getOldConfig = () => {
    fetch("/los/getemailconfigs", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
    })
    .then((res) => res.json())
    .then((data) => {
      // console.log("old config: ", data);
      if(data.KeysPresent || data.OutlookCredentialsPresent){
        setHasOldEmailSetup(true);
      }
    })
  }

  const getGrantId2 = (code, redirect_uri, isNotificationEmail) => {
    const redirect_uri_str = redirect_uri || `${getProtocol()}://${host}/app/management`;
    fetch(
      "/los/nylas/callback?code=" +
        code +
        "&redirect_uri=" +
        redirect_uri_str +
        (isNotificationEmail ? "&isnoreply=true" : ""),
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
        },
      }
    ).then((response) => {
      // console.log("getGrantId2 response: ", response);
      if (response.ok && response.status === 200) {
        response.json().then((data) => {
          console.log("auth response", data);
          const urlParams = new URLSearchParams(window.location.search);
          const type = urlParams.get("type");
          if (type === "notification") {
            data.email && setSystemNotificationsEmail(data.email);
            // type !== 'notification' && setshowIndividualEmail_SuccessDialog(true);
          } else {
            data.email && setIndividualEmail(data.email);
            check()
          }
        });
      }
      if (response.status === 400) {
        console.log("Invalid code");
        console.log("getGrantId2 error", response);
      }
    });
  };

  const check = async () => {
    const config = await getConfig();
    if (checkAccess([UR_Owner]) && !config.NotificationEmail?.Email) {
      setshowIndividualEmail_SuccessDialog(true);
    }
  }

  const isCodeProcessed = useRef(false);
  const isTypeProcessed = useRef(false);
  useEffect(() => {
    const page = pageByMenu(PAGE.MGMT_COMMUNICATION_SETUP, PAGE.COMMUNICATION_SETUP)
    track(STATSIG.COMMON.VIEW, page, { page });
  }, []);
  // 如果query中有code 则默认individualEmail = 'demo@zeitro.com'
  useEffect(() => {
    // console.log('------------useEffect- management-----------')
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const type = urlParams.get("type");
    // getConfig
    getConfig();
    getOldConfig();

    if (type === "notification" && !isTypeProcessed.current) {
      // systemNotificationsEmail
      // console.log("systemNotificationsEmail------------------------", type, systemNotificationsEmail);
      (systemNotificationsEmail === "noreply@zeitro.com") &&
        getGrantId2(code, redirect_uri + "?type=notification", true);
      isTypeProcessed.current = true;
    } else {
      // individualEmail  
      if (code && !isCodeProcessed.current) {
        // console.log("individualEmail------------------------", code);
        !individualEmail && getGrantId2(code, redirect_uri, false);
        isCodeProcessed.current = true;
      }
    }
    getPersonalSiteEmail();
  }, []);

  useEffect(() => {
    if(hasOldEmailSetup){
      setHasEmailSetup(true);
    }
  }, [hasOldEmailSetup])

  useEffect(() => {
    if (
      individualEmail ||
      googleAdminAccount ||
      microsoftAdminAccount ||
      systemNotificationsEmail
    ) {
      if(individualEmail){
        setHasEmailSetup(true);
      }else{
        systemNotificationsEmail !== "noreply@zeitro.com" && setHasEmailSetup(true);
      }
    }
  }, [
    individualEmail,
    googleAdminAccount,
    microsoftAdminAccount,
    systemNotificationsEmail,
  ]);

  const handleTeamEmailBack = () => {
    // console.log("handleTeamEmailBack");
    setshowNotificationEmailDialog(false);
    setshowCompanyEmailDialog(false);
    setshowIndividualEmailDialog(false);
    setSelectedProvider("");
    setGoogleAdminAccount("");
    setMicrosoftAdminAccount("");
    setshowEmailTypeDialog(true);
  };

  const handleNotificationEmailDialogOpen = () => {
    setNotificationEmailInput(systemNotificationsEmail || 'noreply@zeitro.com');
    if(systemNotificationsEmail === 'noreply@zeitro.com'){
      setIsEditDefaultEmail(true);
    }
    setOpenNotificationDailog(true);
  };

  const svp_tag = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="14"
        viewBox="0 0 11 14"
        fill="none"
      >
        <path
          d="M9.25846 5.77396V3.69108C9.25846 2.76731 8.8915 1.88138 8.23829 1.22818C7.58509 0.574973 6.69916 0.208008 5.77539 0.208008C4.85162 0.208008 3.96569 0.574973 3.31249 1.22818C2.65928 1.88138 2.29232 2.76731 2.29232 3.69108V5.77396C1.77066 6.03116 1.33121 6.42895 1.0235 6.92251C0.715799 7.41607 0.552073 7.98576 0.550781 8.56738V10.6572C0.552071 11.4882 0.882754 12.2848 1.47036 12.8724C2.05796 13.46 2.85455 13.7907 3.68555 13.792H7.86523C8.69623 13.7907 9.49282 13.46 10.0804 12.8724C10.668 12.2848 10.9987 11.4882 11 10.6572V8.56738C10.9987 7.98576 10.835 7.41607 10.5273 6.92251C10.2196 6.42895 9.78012 6.03116 9.25846 5.77396ZM6.472 9.96061C6.472 10.1454 6.39861 10.3226 6.26797 10.4532C6.13733 10.5838 5.96014 10.6572 5.77539 10.6572C5.59064 10.6572 5.41345 10.5838 5.28281 10.4532C5.15217 10.3226 5.07878 10.1454 5.07878 9.96061V9.264C5.07878 9.07924 5.15217 8.90206 5.28281 8.77142C5.41345 8.64078 5.59064 8.56738 5.77539 8.56738C5.96014 8.56738 6.13733 8.64078 6.26797 8.77142C6.39861 8.90206 6.472 9.07924 6.472 9.264V9.96061ZM7.86523 5.43262H3.68555V3.69108C3.68555 3.13682 3.90573 2.60526 4.29765 2.21334C4.68957 1.82142 5.22113 1.60124 5.77539 1.60124C6.32965 1.60124 6.86121 1.82142 7.25313 2.21334C7.64505 2.60526 7.86523 3.13682 7.86523 3.69108V5.43262Z"
          fill="#474849"
        />
      </svg>
    );
  };

  const svg_pass = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM6 11.5354L7.41421 10.1212L10.9497 13.6567L16.6064 8L18.0207 9.41421L12.364 15.0709L10.9497 16.4851L10.9496 16.4853L9.53538 15.0711L9.53552 15.0709L6 11.5354Z"
          fill="#13358D"
        />
      </svg>
    );
  };

  const svg_email = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="89"
        height="89"
        viewBox="0 0 89 89"
        fill="none"
      >
        <g filter="url(#filter0_d_296_168)">
          <g clip-path="url(#clip0_296_168)">
            <path
              d="M67.25 10H21.75C16.3652 10 12 14.3652 12 19.75V65.25C12 70.6348 16.3652 75 21.75 75H67.25C72.6348 75 77 70.6348 77 65.25V19.75C77 14.3652 72.6348 10 67.25 10Z"
              fill="#2E605A"
            />
            <path
              d="M61.8976 26.25H27.1023C24.2304 26.25 21.9023 28.5781 21.9023 31.45V53.55C21.9023 56.4219 24.2304 58.75 27.1023 58.75H61.8976C64.7695 58.75 67.0976 56.4219 67.0976 53.55V31.45C67.0976 28.5781 64.7695 26.25 61.8976 26.25Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.7972 25.3496L43.7759 46.2011L43.805 46.2343C44.1878 46.6719 44.812 46.6719 45.1949 46.2343L45.224 46.2011L66.2026 25.3496L67.9926 27.1504L52.5362 42.5131L67.9918 57.8488L66.2034 59.6512L50.7354 44.3031L47.0734 47.9429C45.6849 49.4878 43.315 49.4878 41.9265 47.9429L38.2645 44.3031L22.7965 59.6512L21.0081 57.8488L36.4637 42.5131L21.0073 27.1504L22.7972 25.3496Z"
              fill="#2E605A"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_296_168"
            x="0"
            y="0"
            width="89"
            height="89"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0313726 0 0 0 0 0.0705882 0 0 0 0 0.396078 0 0 0 0.12 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_296_168"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_296_168"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_296_168">
            <rect x="12" y="10" width="65" height="65" rx="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };

  const svg_replace_top = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="15"
        viewBox="0 0 35 15"
        fill="none"
      >
        <path
          d="M2 13H28.5057C32.1804 13 33.9106 8.4608 31.1681 6.01482L26.6667 2"
          stroke="#586570"
          stroke-width="4"
          stroke-linecap="round"
        />
      </svg>
    );
  };

  const svg_replace_bottom = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="15"
        viewBox="0 0 35 15"
        fill="none"
      >
        <path
          d="M33 2H6.49433C2.81956 2 1.0894 6.5392 3.83187 8.98518L8.33333 13"
          stroke="#586570"
          stroke-width="4"
          stroke-linecap="round"
        />
      </svg>
    );
  };

  const svg_logo = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="89"
        height="89"
        viewBox="0 0 89 89"
        fill="none"
      >
        <g filter="url(#filter0_d_296_162)">
          <rect x="12" y="10" width="65" height="65" rx="12" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33.8564 59.0925L32.6345 62.6922C32.0487 64.4182 33.3569 66.2007 35.2096 66.2007H60.9993C63.9974 66.2007 66.428 63.8139 66.428 60.8696L66.4287 32.4368C66.4288 29.4924 63.9982 27.1055 61 27.1055H55.5704L48.3321 48.4301H59.3705L55.7514 59.0925H33.8564Z"
            fill="#1630AC"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33.8575 59.0952H28.4287C25.4305 59.0952 23 56.7084 23 53.764V25.3312C23 22.3868 25.4305 20 28.4287 20H54.2192C56.0719 20 57.3802 21.7825 56.7943 23.5085L55.5724 27.1082H33.8575L30.2383 37.7706H41.0958L33.8575 59.0952Z"
            fill="#081265"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_296_162"
            x="0"
            y="0"
            width="89"
            height="89"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0862745 0 0 0 0 0.188235 0 0 0 0 0.67451 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_296_162"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_296_162"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  };

  const tips = {
    team: "This integration will allow each team member to send from their own address (e.g. jane@zeitro.com)",
    individual: "Only you will use this to send emails.(e.g. jane@gmail.com)",
    notification:
      "This email is used for system notifications, such as two-factor authentication codes, password recovery, reminders, and alerts sent to team members and borrowers.(e.g. support@zeitro.com)",
    integration:
      "Team email: This integration will allow each team member to send from their own address (e.g. jane@zeitro.com)",
  };
  const svg_tips = (type) => {
    return (
      // <div style={{ marginRight: "8px" }}>
        <Tooltip title={tips[type]} placement="bottom">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 17.75C15.1756 17.75 17.75 15.1756 17.75 12C17.75 8.82436 15.1756 6.25 12 6.25C8.82436 6.25 6.25 8.82436 6.25 12C6.25 15.1756 8.82436 17.75 12 17.75ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
              fill="#6E6E70"
            />
            <path
              d="M13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9Z"
              fill="#6E6E70"
            />
            <path d="M11.25 11H12.75V16H11.25V11Z" fill="#6E6E70" />
          </svg>
        </Tooltip>
      // </div>
    );
  };

  const svg_radio_unselected = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle
          cx="12"
          cy="12"
          r="11"
          fill="white"
          stroke="#DBDCDE"
          stroke-width="2"
        />
        <circle cx="12" cy="12" r="5" fill="white" />
      </svg>
    );
  };

  const svg_radio_selected = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle
          cx="12"
          cy="12"
          r="11"
          fill="white"
          stroke="#325CEB"
          stroke-width="2"
        />
        <circle cx="12" cy="12" r="5" fill="#325CEB" />
      </svg>
    );
  };

  const svg_warning = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <rect width="18" height="18" rx="9" fill="#081265" />
        <rect x="8" y="4" width="2" height="7" rx="1" fill="white" />
        <rect
          x="10"
          y="12"
          width="2"
          height="2"
          rx="1"
          transform="rotate(90 10 12)"
          fill="white"
        />
      </svg>
    );
  };

  const tag_integrated = () => {
    return (
      <div className="integrated" style={{marginLeft: 4}}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="10"
          viewBox="0 0 13 10"
          fill="none"
        >
          <rect
            x="0.989258"
            y="4.29297"
            width="2"
            height="7"
            transform="rotate(-45 0.989258 4.29297)"
            fill="#2E605A"
          />
          <rect
            x="11.5957"
            y="0.757324"
            width="2"
            height="10"
            transform="rotate(45 11.5957 0.757324)"
            fill="#2E605A"
          />
        </svg>
        <span style={{ marginLeft: "0px" }}>Integrated</span>
      </div>
    );
  };

  const handleTeamEmailSubmit = () => {
    if (!selectedProvider) {
      setErrorMessage("Please select an email provider");
      return;
    }

    const adminAccount =
      selectedProvider === "google"
        ? googleAdminAccount
        : microsoftAdminAccount;

    if (!adminAccount) {
      setErrorMessage("Please enter an admin account");
      return;
    }

    if (!validateEmail(adminAccount)) {
      setErrorMessage("Please enter a valid admin email address");
      return;
    }

    // TODO: Call API to save provider settings
    // getGoogleAccessToken(adminAccount);

    // return;

    console.log(
      `Setting up ${selectedProvider} with admin account:`,
      adminAccount
    );
    track(STATSIG.COMMUNICATION_SETUP.TEAM_EMAIL, adminAccount, { email: adminAccount });
    setshowCompanyEmailDialog(false);
    setSelectedProvider("");
    setGoogleAdminAccount("");
    setMicrosoftAdminAccount("");
    setErrorMessage("");
  };

  const handleSmsToggle = () => {
    const enabled = (!isSmsEnabled).toString();
    fetch("/los/setsmsalerton", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
      body: JSON.stringify({
        SMSAlertOn: !isSmsEnabled,
      }),
    }).then((response) => {
      // console.log(response);
      if (response.ok && response.status === 200) {
        setIsSmsEnabled(!isSmsEnabled);
        track(STATSIG.COMMUNICATION_SETUP.SMS_NOTIF_SWITCH, enabled, { enabled });
        message.success("SMS alert status changed successfully");
        // console.log("SMS status changed to:", !isSmsEnabled);
      } else {
        console.log("Failed to change SMS alert status");
      }
    });
  };

  const getAuthUrl = async (emailInput, redirect_uri) => {
    let authUrl = "";
    const response = await fetch("/los/nylas/connect?email=" + emailInput, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
      body: JSON.stringify({
        email: emailInput,
        redirect_uri: redirect_uri || `${getProtocol()}://${host}/app/management`,
      }),
    });
    if (response.ok && response.status === 200) {
      const data = await response.json();
      console.log("auth response success", data);
      authUrl = data.url;
      return authUrl;
    } else {
      console.log("auth response err", response);
      return "";
    }
  };

  const handleIndividualEmailSubmit = async () => {
    if (!emailInput) {
      setErrorMessage("Please enter an email address");
      return;
    }

    if (!validateEmail(emailInput)) {
      setErrorMessage("Please enter a valid email address");
      return;
    }

    // if (!differentIndividualEmail()) {
      // setShowDifferentIndividualWarning(true);
      // if (numFlag < 1) {
      //   return;
      // }
    // }

    setLoadingObj({...loadingObj, individualEmail: true});

    const authUrl = await getAuthUrl(emailInput);
    // console.log("authUrl--------", authUrl);

    if (authUrl) {
      track(STATSIG.COMMUNICATION_SETUP.CONNECT, emailInput, { email: emailInput });
      setNumFlag(0);
      await flushThenLeave(() => {
        window.location.href = authUrl;
      });
    }

    // todo
    // setIndividualEmail(emailInput);
    // setshowIndividualEmailDialog(false);
    // setEmailInput("");
    // setErrorMessage("");
  };

  const handleEmailDialogOpen = (type) => {
    // console.log("handleEmailDialogOpen", type);
    if (type === "individual") {
      setCurrentType(type);
      setshowIndividualEmailDialog(true);
      setEmailInput(individualEmail || "");
      setErrorMessage("");
    } else if (type === "system") {
      setCurrentType(type);
      setshowNotificationEmailDialog(true);
      setEmailInput(systemNotificationsEmail || "");
      setErrorMessage("");
    } else if (type === "team") {
      setCurrentType(type);
      setshowCompanyEmailDialog(true);
      setEmailInput(googleAdminAccount || microsoftAdminAccount || "");
      setErrorMessage("");
    }
  };
  const removeIndividualEmail = () => {
    fetch("/los/removeindividualemailgrant", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
    }).then((response) => {
      // console.log(response);
      if (response.ok && response.status === 200) {
        track(STATSIG.COMMUNICATION_SETUP.REMOVE, "individual", { type: "individual" });
        message.success("Individual email removed successfully");
        setIndividualEmail("");
        // handleDefaultSender(false, individualEmail, "individual");
        if(systemNotificationsEmail === "noreply@zeitro.com" && !hasOldEmailSetup){
          setHasEmailSetup(false);
        }
      }
    });
  };

  const removeNotificationEmail = () => {
    fetch("/los/removenotificationemailgrant", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
    }).then((response) => {
      // console.log(response);
      if (response.ok && response.status === 200) {
        track(STATSIG.COMMUNICATION_SETUP.REMOVE, "system", { type: "system" });
        message.success("Notification email removed successfully");
        setSystemNotificationsEmail("noreply@zeitro.com");
        if(!individualEmail && !hasOldEmailSetup){
          setHasEmailSetup(false);
        }
        setIsEditDefaultEmail(true);
      }
    });
  };

  const handleRemoveEmail = (type) => {
    if (type === "individual") {
      setShowRemoveEmailConfirm(true);
      setRemoveType("individual");
    } else if (type === "system") {
      setShowRemoveEmailConfirm(true);
      setRemoveType("system");
    } else if (type === "team") {
      setSelectedProvider("");
      setGoogleAdminAccount("");
      setMicrosoftAdminAccount("");
      // TODO: Call API to remove team email
    }
  };

  const handleEmailTypeDialogOpen = () => {
    track(STATSIG.COMMUNICATION_SETUP.EMAIL_SETUP_BUTTON, "click_open_popup", { type: "click_open_popup" });
    // 区分角色
    if (checkAccess([UR_Owner])) {
      // setshowEmailTypeDialog(true);
      setshowIndividualEmailDialog(true);
      setEmailType(1); // Reset to default team option
    } else {
      setshowIndividualEmailDialog(true);
    }
  };

  const handleEmailTypeSelect = (e) => {
    setEmailType(e.target.value);
  };

  const handleEmailTypeSubmit = () => {
    // console.log("handleEmailTypeSubmit", selectedEmailType);
    if (![1, 2].includes(selectedEmailType)) {
      return;
    }
    setshowEmailTypeDialog(false);
    if (selectedEmailType === 1) {
      // Team email setup
      setshowCompanyEmailDialog(true);
    } else {
      // Individual email setup
      // console.log("handleEmailTypeSubmit00", "individual");
      handleEmailDialogOpen("individual");
    }
  };

  const differentIndividualEmail = () => {
    // console.log("differentIndividualEmail", emailInput, personalSiteEmail);
    // 当前填写的email是否和personal site的email不同
    if(emailInput !== personalSiteEmail) {
      setNumFlag(prev => prev + 1);
    }
    return emailInput === personalSiteEmail;
  };

  const getPersonalSiteEmail = () => {
    let token = sessionStorage.getItem("ZeitroA");
    fetch("/los/getprofilesetup", {
      cache: "no-cache",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
    }).then((response) => {
      if (!response.ok) {
        // console.log(response);
      } else {
        response.json().then((js) => {
          // console.log(js);
          setPersonalSiteEmail(js.Email);
        });
      }
    });
  };

  const handleNotificationEmailSubmit = async () => {
    if(notificationEmailInput === 'noreply@zeitro.com'){
      // todo 从数据库删除noreply@zeitro.com
      setSystemNotificationsEmail(notificationEmailInput);
      setIsEditDefaultEmail(false);
      setOpenNotificationDailog(false);
      return;
    }
    if (!notificationEmailInput) {
      setNotificationErrorMessage("Please enter an email address");
      return;
    }

    if (!validateEmail(notificationEmailInput)) {
      setNotificationErrorMessage("Please enter a valid email address");
      return;
    }

    setLoadingObj({...loadingObj, notificationEmail: true});

    // authentication

    const authUrl = await getAuthUrl(
      notificationEmailInput,
      redirect_uri + "?type=notification"
    );
    // console.log("authUrl--------", authUrl);
    // window.open(authUrl, "_blank");
    if (authUrl) {
      track(STATSIG.COMMUNICATION_SETUP.CONNECT, notificationEmailInput, { email: notificationEmailInput });
      await flushThenLeave(() => {
        window.location.href = authUrl;
      });
    } else {
      window.location.href = authUrl;
    }
  };

  const handleDefaultSender = (checked, email, type) => {
    // console.log("handleDefaultSender", checked, email, type);
    fetch("/los/setdefaultemailgrant", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
      body: JSON.stringify({
        for: checked ? type : type === "individual" ? "team" : "individual",
      }),
    }).then((response) => {
      // console.log(response);
      if (response.ok && response.status === 200) {
        message.success("Default sender set successfully");
        if (type === "team") {
          setIsTeamDefaultSender(checked);
        } else if (type === "individual") {
          setIsIndividualDefaultSender(checked);
        }
        getConfig();
      } else {
        console.log("Failed to set default sender");
      }
    });
  };

  return (
    <div className="CommunicationSetupNew">
      <div className="CommunicationSetupNew-title">Communication setup</div>
      {/* Email setup */}
      <div className="CommunicationSetupNew-card">
        <div className="CommunicationSetupNew-card-title">Email setup</div>
        <div className="CommunicationSetupNew-card-description">
          By default, emails are sent from a Zeitro-branded address. Improve
          email credibility by connecting your own domain or custom sender
          address.{" "}
          <span
            className="CommunicationSetupNew-card-description-link cursor-pointer"
            onClick={() => {
              setShowLearnMoreDialog(true);
            }}
          >
            Learn more
          </span>
        </div>
        {/* not set up */}
        {!hasEmailSetup && (
          <div className="CommunicationSetupNew-card-not-set-up">
            <div className="title">Not set up</div>
            <div
              className="CommunicationSetupNew-card-not-set-up-btn cursor-pointer"
              onClick={() => handleEmailTypeDialogOpen()}
            >
              Set up
            </div>
          </div>
        )}

        {/* set up */}

        {/* team email */}
        {hasEmailSetup && (googleAdminAccount || microsoftAdminAccount) && (
          <div className="CommunicationSetupNew-card-team-email">
            <div className="title-box">
              <div className="title" style={{display: "flex", alignItems: "center"}}>
                Team email {svg_tips("team")}
                {tag_integrated()}
              </div>
              {!checkAccess([UR_Owner]) && (
                <div className="CommunicationSetupNew-card-team-email-set-by-admin">
                  {svp_tag()} Set by admin
                </div>
              )}
              {checkAccess([UR_Owner]) && (
                <div className="btn-box">
                  <div
                    className="edit cursor-pointer"
                    onClick={() => handleEmailDialogOpen("team")}
                  >
                    Edit
                  </div>
                  <div
                    className="remove cursor-pointer"
                    onClick={() => handleRemoveEmail("team")}
                  >
                    Remove
                  </div>
                </div>
              )}
            </div>

            <div className="value-box">
              <div className="value-box-item">
                <span className="label">Provider:</span>
                <span className="value">{selectedProvider}</span>
              </div>
              <div className="email-value">
                <div className="email-value-item">
                  <span className="label">Administrator account:</span>
                  <span className="value">{googleAdminAccount}</span>
                </div>
                {/* {defaultEmail === "team" && (
                  <span className="text">Default sender in use</span>
                )}
                {defaultEmail === "individual" && (
                  <div>
                    <Checkbox
                      checked={isTeamDefaultSender}
                      onChange={(e) =>
                        handleDefaultSender(
                          e.target.checked,
                          googleAdminAccount,
                          "team"
                        )
                      }
                    />
                    <span className="checkbox-text">
                      Set as my default sender
                    </span>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        )}

        {/* divider */}
        {hasEmailSetup && individualEmail && (
          <div className="CommunicationSetupNew-card-divider"></div>
        )}
        {/* individual email */}
        {hasEmailSetup && individualEmail && (
          <div className="CommunicationSetupNew-card-team-email-individual">
            <div className="title-box">
              <div className="title" style={{display: "flex", alignItems: "center"}}>
                <span>Individual email</span>
                {svg_tips("individual")}
                {tag_integrated()}
              </div>
              <div className="btn-box">
                <div
                  className="edit cursor-pointer"
                  onClick={() => handleEmailDialogOpen("individual")}
                >
                  Edit
                </div>
                <div
                  className="remove cursor-pointer"
                  onClick={() => handleRemoveEmail("individual")}
                >
                  Remove
                </div>
              </div>
            </div>
            <div className="value-box-individual">
              <div className="value">{individualEmail || "Not set"}</div>
              {/* {defaultEmail === "individual" && (
                <span className="text">Default sender in use</span>
              )}
              {defaultEmail !== "individual" && (
                <div>
                  <Checkbox
                    checked={isIndividualDefaultSender}
                    onChange={(e) =>
                      handleDefaultSender(
                        e.target.checked,
                        individualEmail,
                        "individual"
                      )
                    }
                  />
                  <span className="checkbox-text">
                    Set as my default sender
                  </span>
                </div>
              )} */}
            </div>
          </div>
        )}

        {/* divider */}
        {hasEmailSetup && systemNotificationsEmail && (
          <div className="CommunicationSetupNew-card-divider"></div>
        )}
        {/* System notifications email */}
        {hasEmailSetup && systemNotificationsEmail && (
          <div className="CommunicationSetupNew-card-team-email-system-notifications">
            <div className="title-box">
              <div className="title" style={{display: "flex", alignItems: "center"}}>
                <span>System notifications email</span>
                {svg_tips("notification")}
                {
                // systemNotificationsEmail !== "noreply@zeitro.com" &&
                 tag_integrated()}
              </div>
              {checkAccess([UR_Owner]) && <div className="btn-box">
                  <div
                    className="edit cursor-pointer"
                    onClick={() => handleNotificationEmailDialogOpen()}
                  >
                    Edit
                  </div>
                  {systemNotificationsEmail !== "noreply@zeitro.com" && <div
                  className="remove cursor-pointer"
                  onClick={() => handleRemoveEmail("system")}
                  >
                    Remove
                  </div>}
                </div>}
            </div>
            <div>
              <div className="value-box-notifications">
                <div className="value">{systemNotificationsEmail}</div>
              </div>
            </div>
          </div>
        )}

        {/* divider */}
        {checkAccess([UR_Owner]) && hasEmailSetup && (!googleAdminAccount && !microsoftAdminAccount) && (
          hasOldEmailSetup && <div className="CommunicationSetupNew-card-divider"></div>
        )}

        {/* {old team email} */}
        {checkAccess([UR_Owner]) && hasEmailSetup && (!googleAdminAccount && !microsoftAdminAccount) && hasOldEmailSetup &&  
          <div className="CommunicationSetupNew-card-team-email-individual" style={{display: "flex", alignItems: "center", marginBottom: 10}}>
            <div className="title-box">
              <div className="title" style={{display: "flex", alignItems: "center"}}>
                <span>Team email</span> {svg_tips("team")} {tag_integrated()}
              </div>
            </div>
            <div className="btn-box">
              <div
                  className="edit cursor-pointer"
                  onClick={() => setShowTeamEmailSetupDialog(true)}
                >
                  Edit
                </div>
            </div>
          </div>
        }

        {/* divider */}
        {hasEmailSetup && !individualEmail && (
          <div className="CommunicationSetupNew-card-divider"></div>
        )}
        {/* not have individual email */}
        {hasEmailSetup && !individualEmail && (
          <div className="CommunicationSetupNew-card-team-email-not-have-individual-email" style={{display: "flex", alignItems: "center", marginBottom: 24}}>
            <span>Want to use your own email</span> 
            <span
              className="CommunicationSetupNew-card-team-email-not-have-individual-email-link cursor-pointer"
              onClick={() => handleEmailDialogOpen("individual")}
            >
              Integrate individual email
            </span>
            {svg_tips("individual")}
          </div>
        )}

        {/* divider */}
        {checkAccess([UR_Owner]) && hasEmailSetup && (!googleAdminAccount && !microsoftAdminAccount) && (
          !hasOldEmailSetup && <div className="CommunicationSetupNew-card-divider"></div>
        )}
        {/* not have team email */}
        {checkAccess([UR_Owner]) && hasEmailSetup && (!googleAdminAccount && !microsoftAdminAccount) && (
          !hasOldEmailSetup  &&
            <div className="CommunicationSetupNew-card-team-email-not-have-individual-email" style={{display: "flex", alignItems: "center"}}>
              <span>Authorize company email</span> 
              <span
                className="CommunicationSetupNew-card-team-email-not-have-individual-email-link cursor-pointer"
                onClick={() => setShowTeamEmailSetupDialog(true)}
              >
                Integrate team email 
                {/* &nbsp; */}
              </span>
              {/* <span>for your team.</span> */}
              {svg_tips("team")}
            </div>
        )}
      </div>

      {/* SMS */}
      <div className="CommunicationSetupNew-card">
        <div className="CommunicationSetupNew-card-title">
          SMS notifications
        </div>
        <div className="CommunicationSetupNew-card-description">
          Stay informed with real-time text alerts when a borrower submits an
          application, selects a rate, or signs up through your landing page.
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className="CommunicationSetupNew-card-switch-box">
            <Switch
              // checkedChildren={check_svg()}
              // unCheckedChildren={close_svg()}
              checked={isSmsEnabled}
              onChange={handleSmsToggle}
              style={{ marginRight: "10px" }}
            />
            {isSmsEnabled ? "SMS alerts are ON" : "SMS alerts are OFF"}
          </div>
          <span className="CommunicationSetupNew-card-description-sms">
          {isSmsEnabled ? 'You’ll receive text updates for borrower activity.' : 'You won’t receive borrower activity updates via text.'}
          </span>
        </div>
      </div>

      {/* email type modal */}
      <Modal
        width={566}
        className="CommunicationSetupNew-email-type-modal"
        title=""
        open={showEmailTypeDialog}
        onCancel={() => setshowEmailTypeDialog(false)}
        centered
        footer={null}
      >
        <div className="modal-title">Email setup </div>
        <div className="modal-content">
          <div className="modal-description">
            Who will use this email setup?
          </div>
          <div className="modal-radio-group">
            <div
              className="modal-radio-group-item"
              onClick={() => selectedEmailType !== 1 && setSelectedEmailType(1)}
            >
              <div className="modal-radio-group-item-svg">
                {selectedEmailType === 1
                  ? svg_radio_selected()
                  : svg_radio_unselected()}
              </div>
              <div className="modal-radio-group-item-text">
                <span className="modal-radio-group-item-text-title">
                  My team
                </span>
                <span className="modal-radio-group-item-text-description">
                  This integration will allow each team member to send from
                  their own address (e.g. jane@zeitro.com)
                </span>
              </div>
            </div>
            <div
              className="modal-radio-group-item"
              onClick={() => selectedEmailType !== 2 && setSelectedEmailType(2)}
            >
              <div className="modal-radio-group-item-svg">
                {selectedEmailType === 2
                  ? svg_radio_selected()
                  : svg_radio_unselected()}
              </div>
              <div className="modal-radio-group-item-text">
                <span className="modal-radio-group-item-text-title">
                  Just myself
                </span>
                <span className="modal-radio-group-item-text-description">
                  Only you will use this to send emails.
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-btn-box">
          <div
            className={
              selectedEmailType
                ? "modal-btn-box-button-connect cursor-pointer"
                : "modal-btn-box-button-connect-disabled"
            }
            onClick={handleEmailTypeSubmit}
          >
            Connect
          </div>
        </div>
      </Modal>

      {/* company email modal */}
      <Modal
        width={942}
        className="CommunicationSetupNew-company-email-modal"
        title=""
        open={showCompanyEmailDialog}
        onCancel={() => setshowCompanyEmailDialog(false)}
        centered
        footer={null}
      >
        <div className="modal-title">Team Email setup</div>
        <div className="modal-content">
          <div className="modal-subtitle">Select your email provider</div>
          <div className="CommunicationSetupNew-card-btn-group">
            <div
              className={
                selectedProvider === "google"
                  ? "CommunicationSetupNew-card-btn-radio-selected"
                  : "CommunicationSetupNew-card-btn-radio"
              }
              onClick={(e) => {
                selectedProvider !== "google" && setSelectedProvider("google");
                selectedProvider !== "google" && setMicrosoftAdminAccount("");
              }}
            >
              <div className="CommunicationSetupNew-card-btn-radio-circle">
                {selectedProvider !== "google"
                  ? svg_radio_unselected()
                  : svg_radio_selected()}
              </div>
              <span>Google</span>
              <img src="/images/google-logo.png" alt="google" />
            </div>
            <div
              className={
                selectedProvider === "microsoft"
                  ? "CommunicationSetupNew-card-btn-radio-selected"
                  : "CommunicationSetupNew-card-btn-radio"
              }
              onClick={(e) => {
                selectedProvider !== "microsoft" &&
                  setSelectedProvider("microsoft");
                selectedProvider !== "microsoft" && setGoogleAdminAccount("");
              }}
            >
              <div className="CommunicationSetupNew-card-btn-radio-circle">
                {selectedProvider !== "microsoft"
                  ? svg_radio_unselected()
                  : svg_radio_selected()}
              </div>
              <span>Microsoft</span>
              <img src="/images/microsoft-logo.png" alt="microsoft" />
            </div>
          </div>
          <div
            className="modal-description"
            style={{ marginBottom: !selectedProvider ? "312px" : "" }}
          >
            *Only Google Workspace and Microsoft work accounts are supported.
          </div>

          {/* Google admin account */}
          {selectedProvider === "google" && (
            <div className="modal-admin-account">
              <div className="modal-admin-account-title">
                Administrator account
              </div>
              <div className="modal-admin-account-description">
                Enter Google admin account email that you use to log into google
                admin console.
              </div>
              <Input
                value={googleAdminAccount}
                onChange={(e) => setGoogleAdminAccount(e.target.value)}
                className="modal-admin-account-input"
                placeholder="Example: admin@yourcompany.com"
              />
            </div>
          )}

          {/* Microsoft admin account */}
          {selectedProvider === "microsoft" && (
            <div className="modal-admin-account">
              <div className="modal-admin-account-title">
                Microsoft admin account
              </div>
              <div className="modal-admin-account-description">
                Enter the email address used to manage your organization's
                Microsoft email (e.g. Microsoft 365, Exchange Online).
              </div>
              <Input
                value={microsoftAdminAccount}
                onChange={(e) => setMicrosoftAdminAccount(e.target.value)}
                className="modal-admin-account-input"
                placeholder="Example: admin@yourcompany.com"
              />
            </div>
          )}
        </div>

        {/* footer */}
        <div className="modal-footer">
          <div
            className="modal-footer-button-back cursor-pointer"
            onClick={() => handleTeamEmailBack()}
          >
            Go back
          </div>
          {!googleAdminAccount && !microsoftAdminAccount && (
            <div className="modal-footer-button-connect-disabled">Connect</div>
          )}
          {selectedProvider &&
            (googleAdminAccount || microsoftAdminAccount) && (
              <div
                className="modal-footer-button-connect cursor-pointer"
                onClick={handleTeamEmailSubmit}
              >
                Connect
              </div>
            )}
        </div>
      </Modal>

      {/* select individual email modal */}
      <Modal
        width={566}
        className="CommunicationSetupNew-individual-email-modal"
        title=""
        open={showIndividualEmailDialog}
        onCancel={() => {
          setshowIndividualEmailDialog(false);
          setEmailInput("");
          setErrorMessage("");
        }}
        centered
        footer={null}
      >
        <div className="modal-title">Individual email setup </div>
        <div
          className="modal-content"
          style={{ borderTop: "1px solid #E5E5E5", borderBottom: "none" }}
        >
          <div style={{ marginBottom: "0px" }} className="modal-content-address-title">Your email address</div>
          <Input
            allowClear={true}
            className="modal-content-address-input"
            placeholder="Example: name@gmail.com"
            status={errorMessage ? "error" : ""}
            // suffix={errorMessage ? <CloseCircleOutlined /> : null}
            value={emailInput}
            onChange={(e) => {
              setEmailInput(e.target.value);
              setErrorMessage("");
              if (e.target.value && !personalSiteEmail.startsWith(e.target.value)) {
                setShowDifferentIndividualWarning(true);
              }else{
                setShowDifferentIndividualWarning(false);
              }
            }}
          />
          {showDifferentIndividualWarning && (
            <div className="modal-content-individual-email-warning">
              {<div style={{ width: "18px", height: "18px", display: "flex"}}>{svg_warning()}</div>}
              <div className="modal-content-individual-email-warning-description">
                <span>
                  This email is{" "}
                  <span className="modal-content-individual-email-warning-description-bold">
                    different from
                  </span>{" "}
                  the one you use on your Personal site ({personalSiteEmail}).
                </span>
                <span>For consistency, we recommend using the same email.</span>
              </div>
            </div>
          )}
          {errorMessage && (
            <div style={{ color: "red", marginTop: "8px" }}>{errorMessage}</div>
          )}
          {/* integretion team email */}
          {checkAccess([UR_Owner]) && (
            <div className="integration-team-box">
              <div className="text" style={{marginRight: 4}}>Authorize company email</div>
              <div
              className="start cursor-pointer"
              onClick={() => setShowTeamEmailSetupDialog(true)}
            >
              Integrate team email
              </div>
              {svg_tips("integration")}
            </div>
          )}
        </div>
        {/* footer */}
        <div className="modal-footer" style={{ marginTop: "200px" }}>
          <div
            className={`modal-footer-button-${
              emailInput ? ("connect cursor-pointer" + (loadingObj.individualEmail ? " connect-btn-loading" : "")) : "connect-disabled"
            }`}
            onClick={() => {
              handleIndividualEmailSubmit();
            }}
          >
            Connect {loadingObj.individualEmail && <Spin/>}
          </div>
        </div>
      </Modal>

      {/* learn more modal */}
      <Modal
        width={556}
        className="CommunicationSetupNew-learn-more-modal"
        title=""
        open={showLearnMoreDialog}
        onCancel={() => setShowLearnMoreDialog(false)}
        centered
        footer={null}
      >
        <div className="modal-content">
          <div className="CommunicationSetupNew-learn-more-modal-title">
            Send emails from your own inbox
          </div>
          <div className="CommunicationSetupNew-learn-more-modal-content-box">
            <div>{svg_email()}</div>
            <div>
              <div>{svg_replace_top()}</div>
              <div>{svg_replace_bottom()}</div>
            </div>
            <div>{svg_logo()}</div>
          </div>
          <div className="CommunicationSetupNew-learn-more-modal-subtitle">
            By default, emails are sent from a Zeitro-branded address. Connect
            your own email account to use a team-wide sender identity —
            improving personalization and credibility.
          </div>
          <div className="CommunicationSetupNew-learn-more-modal-description">
            Once integrated, these emails will be sent from the connected inbox:
          </div>
          <div className="CommunicationSetupNew-learn-more-modal-list">
            <div>
              {svg_pass()}
              <span className="CommunicationSetupNew-learn-more-modal-text">
                Borrower invitation
              </span>
            </div>
            <div>
              {svg_pass()}
              <span className="CommunicationSetupNew-learn-more-modal-text">
                Document requests & reminders
              </span>
            </div>
            <div>
              {svg_pass()}
              <span className="CommunicationSetupNew-learn-more-modal-text">
                Rate updates
              </span>
            </div>
            <div>
              {svg_pass()}
              <span className="CommunicationSetupNew-learn-more-modal-text">
                Team memeber invitation
              </span>
            </div>
          </div>
        </div>
      </Modal>

      {/* team email setup dialog */}
      <Modal
        open={showTeamEmailSetupDialog}
        width={942}
        style={{ overflow: "hidden" }}
        footer={null}
        centered
        destroyOnClose
        onCancel={() => setShowTeamEmailSetupDialog(false)}
        className="CommunicationSetupNew-team-email-setup-dialog"
      >
        <div className="CommunicationSetupNew-team-email-setup-dialog-title">
          Team email setup
        </div>
        <div className="CommunicationSetupNew-team-email-setup-dialog-content">
          <TeamEmailSetupContent onClose={() => setShowTeamEmailSetupDialog(false)}></TeamEmailSetupContent>
        </div>
        {/* <div className="CommunicationSetupNew-team-email-setup-dialog-footer"> */}
          {/* <div className="footer-text">
            Once you have your Google workspace account ready, you can contact
            us.
          </div> */}
          {/* <div 
            className="footer-button-contact cursor-pointer"
            onClick={() => {
              // 这里可以添加联系支持团队的逻辑
              window.open('mailto:support@zeitro.com');
              setShowTeamEmailSetupDialog(false);
            }}
          >
            Contact us
          </div> */}
        {/* </div> */}
      </Modal>

      {/* 个人邮箱设置成功弹窗 */}
      <Modal
        open={showIndividualEmail_SuccessDialog}
        width={566}
        title=""
        footer={null}
        onCancel={() => setshowIndividualEmail_SuccessDialog(false)}
        className="CommunicationSetupNew-individual-email-success-modal"
      >
        <div className="modal-title">Individual email setup </div>
        <div className="modal-content-individual-email-success-icon">
          <svg width="100" height="72" viewBox="0 0 100 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M80.305 60.8765H6.86691C3.13107 60.8765 0.103027 57.8478 0.103027 54.1126V6.76388C0.103027 3.02805 3.13169 0 6.86691 0H80.3053C84.0411 0 87.0692 3.02866 87.0692 6.76388V54.1123C87.0689 57.8478 84.0405 60.8765 80.305 60.8765Z" fill="#DFE4F3"/>
            <path d="M80.3048 0H43.6738V60.8762H80.3048C84.0407 60.8762 87.0687 57.8475 87.0687 54.1123V6.76388C87.0687 3.02866 84.0404 0 80.3048 0Z" fill="#C3CCEA"/>
            <path d="M43.586 34.7865L87.0689 8.69677V6.76388C87.0689 3.02805 84.0402 0 80.305 0H6.86691C3.13169 0 0.103027 3.02866 0.103027 6.76388V8.69677L43.586 34.7865Z" fill="#C3CCEA"/>
            <path d="M87.0687 6.76388C87.0687 3.02866 84.04 0 80.3048 0H43.6738V34.7339L87.0687 8.69677V6.76388Z" fill="#8895BC"/>
            <rect x="61.1538" y="33.2642" width="38.7434" height="38.7434" rx="19.3717" fill="#454E92"/>
            <path d="M89.2506 43.9115C91.6597 46.3208 91.6597 50.227 89.2506 52.6364L87.6822 54.2048C87.3438 54.5433 87.3438 55.092 87.6822 55.4304L88.2016 55.9498C88.54 56.2882 89.0887 56.2882 89.4271 55.9498L90.9955 54.3813C94.3683 51.0084 94.3683 45.5396 90.9955 42.1665C87.6226 38.7935 82.1541 38.7935 78.7811 42.1665L77.2128 43.7349C76.8744 44.0734 76.8744 44.6221 77.2128 44.9605L77.7322 45.4799C78.0706 45.8184 78.6193 45.8184 78.9577 45.4799L80.5261 43.9115C82.9352 41.5022 86.8414 41.5022 89.2506 43.9115Z" fill="white"/>
            <path d="M71.8004 61.3605C74.2097 63.7699 78.1158 63.7699 80.5249 61.3605L82.0933 59.7921C82.4317 59.4536 82.9805 59.4536 83.3189 59.7921L83.8382 60.3114C84.1766 60.65 84.1766 61.1986 83.8382 61.537L82.2698 63.1055C78.897 66.4786 73.4284 66.4786 70.0555 63.1055C66.6827 59.7324 66.6827 54.2637 70.0555 50.8906L71.6239 49.3222C71.9623 48.9838 72.511 48.9838 72.8494 49.3222L73.3688 49.8416C73.7072 50.18 73.7072 50.7288 73.3688 51.0672L71.8004 52.6357C69.3912 55.0449 69.3912 58.9512 71.8004 61.3605Z" fill="white"/>
            <path d="M84.7059 48.0902C84.3251 47.7095 83.7079 47.7095 83.3271 48.0902L75.9813 55.4364C75.6006 55.8172 75.6006 56.4344 75.9813 56.8152L76.3475 57.1813C76.7282 57.5621 77.3456 57.5621 77.7262 57.1813L85.072 49.8353C85.4527 49.4545 85.4527 48.8371 85.072 48.4564L84.7059 48.0902Z" fill="white"/>
          </svg>
        </div>
        <div className="modal-description">
          ✅ Individual email setup complete
        </div>
        <div className="modal-content">
          <div className="modal-content-individual-email-success-description">
            You'll now send emails from your own connected email — keeping
            communication more personal and traceable.
          </div>
        </div>
        <div className="modal-footer">
          <div
            className="modal-footer-button cursor-pointer"
            onClick={() => {
              setOpenNotificationDailog(true);
              setshowIndividualEmail_SuccessDialog(false);
            }}
          >
            Set up email for system notifications
          </div>
        </div>
      </Modal>

      {/* select notification email modal */}
      <Modal
        width={566}
        className="CommunicationSetupNew-individual-email-modal"
        title=""
        open={openNotificationDailog}
        onCancel={() => {
          setNotificationErrorMessage("");
          setOpenNotificationDailog(false);
        }}
        centered
        footer={null}
      >
        <div className="modal-title">System notifications email </div>
        <div
          className="modal-content"
          style={{ borderTop: "1px solid #E5E5E5", borderBottom: "none" }}
        >
          <div style={{ marginBottom: "0px" }} className="modal-content-address-title">
            Set up email for system notifications
          </div>
          { systemNotificationsEmail === 'noreply@zeitro.com' && isEditDefaultEmail
          ? 
          <div className="notification-email-content-default-email-box-new">
            <div style={{display: "flex", alignItems: "center"}}>
              <span className="notification-email-content-default-email">{systemNotificationsEmail} &nbsp;</span>
              <span className="notification-email-content-default-email-text">(Default)</span>
            </div>
            <div className="notification-email-content-default-email-edit-btn cursor-pointer" onClick={() => setIsEditDefaultEmail(false)}>
              Edit
            </div>
          </div>
          :
          <Input
            style={{marginBottom: notificationErrorMessage ? "0px" : "8px"}}
            allowClear={true}
            className="modal-content-address-input"
            placeholder="Example: name@gmail.com"
            status={notificationErrorMessage ? "error" : ""}
            // suffix={notificationErrorMessage ? <CloseCircleOutlined /> : null}
            value={notificationEmailInput}
            onChange={(e) => {
              setNotificationEmailInput(e.target.value);
              setNotificationErrorMessage("");
            }}
          />}
          {notificationErrorMessage && (
            <div style={{ color: "red", marginTop: "8px" }}>
              {notificationErrorMessage}
            </div>
          )}
          {/* tool tip */}
          <div className="tool-tip-box">
            This email is used for system notifications, such as two-factor
            authentication codes, password recovery, reminders, and alerts sent
            to team members and borrowers.
          </div>
        </div>
        {/* footer */}
        <div
          className="modal-footer"
          style={{ marginTop: "200px", justifyContent: "space-between" }}
        >
          <div
            className="modal-footer-skip"
            onClick={() => {
              setOpenNotificationDailog(false);
            }}
          >
            Skip
          </div>
          <div
            style={{ width: loadingObj.notificationEmail ? "130px" : "111px" }}
            className={`modal-footer-button-${
              notificationEmailInput
                ? ("connect cursor-pointer" + (loadingObj.notificationEmail ? " connect-btn-loading" : ""))
                : "connect-disabled"
            }`}
            onClick={() => {
              handleNotificationEmailSubmit();
            }}
          >
            Finish {loadingObj.notificationEmail && <Spin/>}
          </div>
        </div>
      </Modal>

      {/* Remove email confirmation dialog */}
      <Modal
        open={showRemoveEmailConfirm}
        width={410}
        footer={null}
        onCancel={() => setShowRemoveEmailConfirm(false)}
        className="remove-notification-email-confirm-dialog"
      >
        <div className="remove-notification-email-confirm-content">
          <div className="remove-notification-email-confirm-title">
            {removeType === "system" ? "Remove email" : "Remove email"}
          </div>
          <div className="remove-notification-email-confirm-content-text">
            <div style={{marginBottom: "10px"}}>Removing this email will disconnect it from your account. Emails will be sent from the default Zeitro-branded address instead.</div>
            <div>You can re-integrate an email anytime from the Communication Integration settings.</div>
          </div>
          <div className="remove-notification-email-confirm-buttons">
            <div
              className="remove-notification-email-confirm-remove cursor-pointer"
              onClick={() => {
                if (removeType === "individual") {
                  removeIndividualEmail();
                } else if (removeType === "system") {
                  removeNotificationEmail();
                }
                setShowRemoveEmailConfirm(false);
              }}
            >
              Remove
            </div>
            <div
              className="remove-notification-email-confirm-cancel cursor-pointer"
              onClick={() => setShowRemoveEmailConfirm(false)}
            >
              Cancel
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
